import { useEffect, useRef } from 'react'
import * as jdenticon from 'jdenticon'

interface IdenticonProps {
  source: string
  size?: number
  className?: string
}

export function Identicon({ source, size = 48, className }: IdenticonProps) {
  const svgRef = useRef<SVGSVGElement>(null)

  useEffect(() => {
    if (svgRef.current) {
      jdenticon.update(svgRef.current, source)
    }
  }, [source])

  return (
    <svg
      ref={svgRef}
      width={size}
      height={size}
      className={className}
      data-jdenticon-value={source}
    />
  )
}